/* eslint-disable */
import httpClient from '@/utils/httpClient'

class TenantsPaymentRepository extends httpClient {
  resource = '/tenants/registry'

  async getDriverPayments (params) {
    const response = await this.get(`${this.resource}/surcharges`, { params })

    return response ?? []
  }

  async getDriverOutAmount (params) {
    const response = await this.get(`${this.resource}/give-out-amount`, { params })

    return response ?? []
  }
}

export default TenantsPaymentRepository
